export default __webpack_public_path__ + "static/media/Packard 04-14-04 001.016d69e4.jpg";